/* eslint-disable no-console */
/* eslint-disable react/no-danger */
import React, { useEffect, useState } from 'react';
import { Box, HStack, Skeleton } from '@chakra-ui/react';
import { useSelector } from 'react-redux';

import DOMPurify from 'dompurify';
import { ApplicationState } from '~/store/store';
import TextEditor from '~/components/TextEditor';
import { ProposalSectionProps } from '~/store/ducks/Proposal/types';
import { toastError, toastSuccess } from '~/helpers/toast';
import ProposalService from '~/store/ducks/Proposal/services';
import { Button } from '~/components/Form/Button/Button_Styles';
import Warning from '~/components/Form/Warning';
import markdownConverter from '~/helpers/markdownConverter';

const Presentation: React.FC<ProposalSectionProps> = ({ isExpanded }) => {
  const { id: projectId } = useSelector((state: ApplicationState) => state.project);
  const { data: proposalData } = useSelector((state: ApplicationState) => state.proposal);
  const [loading, setLoading] = useState<boolean>(false);
  const [buttonLoading, setButtonLoading] = useState<boolean>(false);
  const [isTextModified, setIsTextModified] = useState<boolean>(false);
  const [presentationTemplate, setPresentationTemplate] = useState(null);
  const [presentation, setPresentation] = useState(null);
  const [markdown, setMarkdown] = useState('');

  const submitContentEditor = (mk) => {
    if (markdown && mk !== markdown) {
      setIsTextModified(true);
    }

    setMarkdown(mk);
  };

  const fetchPresentationTemplate = async () => {
    try {
      setLoading(true);
      const response = await ProposalService.getPresentationTemplate();
      setPresentationTemplate(response.data);
    } catch (err) {
      console.error(err);
      toastError('proposal', 'Erro ao recuperar apresentação.');
    } finally {
      setLoading(false);
    }
  };

  const fetchPresentation = async () => {
    try {
      setLoading(true);
      const response = await ProposalService.getPresentation(projectId, proposalData.id);
      setPresentation(response.data);
    } catch (err) {
      console.error(err);
      toastError('proposal', 'Erro ao recuperar apresentação.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (isExpanded) {
      fetchPresentationTemplate();
      fetchPresentation();
    }
  }, [isExpanded]);

  const handleSubmit = async () => {
    const data = {
      ...presentation,
      text: markdown,
    };

    try {
      setButtonLoading(true);
      await ProposalService.savePresentation(projectId, proposalData.id, data);
      toastSuccess('proposal', 'Salvo com sucesso!');
      setIsTextModified(false);
    } catch (err) {
      console.error(err);
      toastError('proposal', 'Erro ao salvar seção.');
    } finally {
      setButtonLoading(false);
    }
  };

  return (
    <Skeleton isLoaded={!loading}>
      {presentation && (
        <Box className="proposal__section">
          <div
            className="proposal__text"
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(markdownConverter(presentationTemplate?.text)),
            }}
          />
          <TextEditor markdown={presentation?.text} saveContentEditor={submitContentEditor} />
        </Box>
      )}
      {isTextModified && <Warning message="As alterações ainda não foram salvas." />}
      <HStack mt={5} justify="end">
        <Button isLoading={buttonLoading} disabled={!isTextModified} $primary onClick={handleSubmit}>
          Salvar
        </Button>
      </HStack>
    </Skeleton>
  );
};

export default Presentation;
